import script from "./AchievementsFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsFilters.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsFilters.vue?vue&type=style&index=0&id=06389668&lang=scss"

const __exports__ = script;

export default __exports__